import React, { useEffect, useRef } from 'react'
import { useRoot } from 'Hooks'
import { CheckOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const ModalStyled = styled.div`
  z-index: 99999999 !important;
  position: fixed;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);

  background-color: white;

  padding: 8px;
  font-size: 14px;
  line-height: 1.5715;
  word-wrap: break-word;

  min-width: 40%;
  width: 500px;
  border-radius: 4px;
  box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%);
`

const ModalError = () => {
  const { t } = useTranslation('error_message')
  const refClose = useRef()
  const timeClose = 3
  let {
    type, message, isShowModalMessage,
    hideModalMessageAction
  } = useRoot()
  if (message == null) {
    if (type === 'success') {
      message = 'Success!'
    } else {
      message = 'Error!'
    }
  }

  useEffect(() => {
    if (isShowModalMessage) {
      refClose.current = setInterval(() => {
        hideModalMessageAction()
      }, timeClose * 1000)
    }
    return () => {
      clearInterval(refClose.current)
    }
  }, [isShowModalMessage])

  return (
    <>
      {isShowModalMessage && (
        <ModalStyled>
          <div style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
            {
            type === 'success' ? <CheckOutlined style={{ color: 'green', fontSize: '24px' }} />
              : <CloseCircleOutlined style={{ color: 'red', fontSize: '24px' }} />
          }
            &nbsp;&nbsp;&nbsp;{t(message)}
          </div>
        </ModalStyled>
      )}
    </>
  )
}
export default ModalError
